// @flow

import FileSaver from 'file-saver';

type DownloadUtil = (file: *, fileName: string)=>void;

const downloadFile: DownloadUtil = (file, fileName) => {
    if (file instanceof Blob) {
        FileSaver.saveAs(file, fileName);
    } else {
        FileSaver.saveAs(new File([file], fileName), fileName);
    }
};

export {downloadFile};
